var link_viewer_wrapper_rtlignore_default = {
  "anchor": "C6o2O",
  "link": "_0OdRw"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
